export default __webpack_public_path__ + "df1428780331b2d83479b8a35f617b1c.png";